import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "md:flex items-center justify-between p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold" }, "Daftar Transaksi Bus Berjalan", -1)
const _hoisted_3 = { class: "w-full md:w-1/3" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "container-spinner" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex items-center gap-4" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "flex items-center gap-3 mb-2" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "text-grey text-sm font-bold" }
const _hoisted_14 = {
  key: 0,
  class: "background-green-lighten-5 text-green border-success rounded-lg px-2 text-xs font-bold"
}
const _hoisted_15 = { class: "flex items-center gap-3" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "text-grey text-xs" }
const _hoisted_18 = { class: "flex items-end" }
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium" }, "Total pendapatan trayek", -1)
const _hoisted_21 = { class: "text-primary text-2xl font-extrabold" }

import { getCurrentInstance, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import Card from 'primevue/card'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import ProgressSpinner from 'primevue/progressspinner'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import numberFormat from '@/utils/helpers/numberFormat'
import Popper from 'vue3-popper'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import { useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnclosedTrayekTransaction',
  setup(__props) {

const dummy = ref([
  { IsTol: true },
  { IsTol: false }
])
const transactionPpsEndpoint = 'transaction/v2/TransactionPps'
const dashboardEndpoint = 'transaction/v2/Dashboards'

const store = useStore()
const router = useRouter()
const isLoading = ref(false)
const inputSearch = ref('')
const app = getCurrentInstance()
const {
  $icon, $toast
} = app!.appContext.config.globalProperties
const icon = $icon
const dataSource = ref([]) as any

const filters = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  custom: [] as any
})

const onSearch = () => {
  console.log('search', inputSearch.value)
  filters.value.search = inputSearch.value
  filters.value.pageNumber = 1
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const getAllData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${dashboardEndpoint}/transactions/preview/by-trayek`, returnUrlPrams(filters.value)).then((response) => {
    const { error, result, count } = response
    if (!error) {
      filters.value.totalRecords = count
      dataSource.value = result
    }
  })
  store.dispatch('hideLoading')
}

const toDetailPage = (id: any) => {
  const encryptedId = encryptDecriptMethods.encrypt(id)
  router.push({
    name: 'unclosed-transaction-detail',
    params: {
      id: encryptedId
    }
  })
}

onMounted(() => {
  getAllData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow" }, {
      title: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createVNode(InputIconRight, {
                class: "input-search-header-custom",
                placeholder: "Cari disini...",
                modelValue: inputSearch.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputSearch).value = $event)),
                canClick: true,
                icon: _unref(icon).svg.searchEva,
                onSubmitInput: onSearch,
                onKeyup: _withKeys(onSearch, ["enter"]),
                disabled: false
              }, null, 8, ["modelValue", "icon", "onKeyup"])
            ])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(ProgressSpinner), {
              style: {"width":"70px","height":"70px"},
              class: "spinner-data-list"
            })
          ], 512), [
            [_vShow, isLoading.value]
          ]),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource), (data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: data,
                    class: "mb-4"
                  }, [
                    _createVNode(_unref(Card), { class: "card-no-shadow" }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_unref(Popper), {
                            arrow: "",
                            hover: "",
                            placement: "bottom",
                            content: data.IsTol ? 'Tol' : 'Non Tol'
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: require(data.IsTol ? '@/assets/img/icon/toll-blue-fill.svg' : '@/assets/img/icon/toll-blue-fill-with-cross.svg'),
                                alt: "toll"
                              }, null, 8, _hoisted_8)
                            ]),
                            _: 2
                          }, 1032, ["content"]),
                          _createElementVNode("div", {
                            class: "text-2xl font-bold cursor-pointer",
                            onClick: ($event: any) => (toDetailPage(data))
                          }, _toDisplayString(data?.TrayekName ?? '-'), 9, _hoisted_9)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("img", {
                                src: require('@/assets/img/icon/action/change-orange.svg'),
                                alt: "change"
                              }, null, 8, _hoisted_12),
                              _createElementVNode("div", _hoisted_13, _toDisplayString(`${data?.TrayekRoutes[0]?.RouteName} ${data?.TrayekRoutes.length > 1 ? `- ${data?.TrayekRoutes[1]?.RouteName}` : ''}`), 1),
                              (data?.TrayekClassName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(data?.TrayekClassName ?? '-'), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("img", {
                                src: require('@/assets/img/icon/bus-outlined-black.svg'),
                                alt: "change"
                              }, null, 8, _hoisted_16),
                              _createElementVNode("div", _hoisted_17, _toDisplayString(`Jumlah Transaksi Bus Berjalan: ${_unref(numberFormat)(data?.TotalTransaction ?? 0)}`), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(rupiahFormat)(data?.TotalTicketAmount ?? 0)), 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})